module.exports = __webpack_public_path__ + "static/portrait-53576a2cd420816149faaf2a11322826.jpg";